export default "__VITE_ASSET__600191c1__"